var render = function render(){var _vm=this,_c=_vm._self._c;return _c('arrayed-text-field',_vm._b({attrs:{"item-icon":"sms-dark","item-edit-label":_vm.$t('station.arrayedItems.sms.itemHeader')},on:{"change":function($event){return _vm.$emit('change', $event)},"source-change":function($event){return _vm.$emit('source-change', $event)}}},'arrayed-text-field',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }